import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 14 }) => (
  <div className="inline-flex items-center gap-0.5">
    {[1,2,3,4,5].map(i => (
      <Star key={i} width={size} height={size}
        className={i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-zinc-600"} />
    ))}
  </div>
);

export const StatusBadge = ({ status }) => {
  const labels = {
    open: "Aberta",
    negotiating: "Negociando",
    accepted: "Aceita",
    in_progress: "Em andamento",
    completed: "Concluída",
    cancelled: "Cancelada",
  };
  return <span translate="no" className={`badge-pill status-${status} notranslate`}>{labels[status] || status}</span>;
};

export const BadgeTier = ({ badge, verified }) => {
  if (!badge && !verified) return null;
  const colors = {
    bronze: "bg-orange-900/40 text-orange-300 border-orange-800",
    prata: "bg-zinc-700/40 text-zinc-200 border-zinc-500",
    ouro: "bg-amber-900/40 text-amber-300 border-amber-700",
    master: "bg-red-900/40 text-red-300 border-red-700",
  };
  return (
    <span className="inline-flex gap-1 items-center">
      {badge && (
        <span className={`badge-pill border ${colors[badge.key] || colors.bronze}`}>
          ⭑ {badge.label}
        </span>
      )}
      {verified && (
        <span className="badge-pill border bg-blue-900/40 text-blue-300 border-blue-700" title="Perfil Verificado">
          ✓ Verificado
        </span>
      )}
    </span>
  );
};

export const currency = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);
